import PercentagePie from './PercentagePie'

export default PercentagePie
